import { useCheckRole } from '@ospace/auth'
import { userTypes } from '@ospace/core-auth'
import { ErrorBoundary } from '@ospace/shared'

import { ObserverPage } from './ObserverPage'

const Controller = () => {
  useCheckRole([userTypes.Admin])
  return <ObserverPage kind='contact' />
}

export const ContactsObserverPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
